/**
 * Created by Antonio date/is/today
 */
import {BetLineNumber} from "@nolimitcity/slot-game/bin/core/betline/BetLineNumber";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {HarlequinGameConfig} from "../HarlequinGameConfig";
import {BetLine} from "@nolimitcity/slot-game/bin/core/betline/BetLine";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Timeline, TimelineLite, TimelineMax} from "gsap";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {HarlequinIndividualWinAmountView} from "../gameround/presentations/HarlequinIndividualWinAmountView";



export interface IBetLinesViewConfig {
    readonly map:number[]; // all the left ones first then right ones from top to bottom.
}

export interface ISpriteHash {
    [details: string] : PIXI.Sprite;
}

export interface IHash {
    [details: string] : string;
}

export class HarlequinBetlineView extends BaseView {

    private readonly _numberFactoryMethod:(index:number) => BetLineNumber;
    private readonly _lineFactoryMethod:(index:number, numberPosition:number[], betLineData:number[]) => BetLine;

    private readonly _config:IBetLinesViewConfig;
    protected readonly _betLines:BetLine[] = [];
    protected readonly _betLineNumbers:BetLineNumber[] = [];

    private _betLinesData:number[][];

    protected _resourcesLoaded:boolean = false;
    protected _dataInitialized:boolean = false;
    private _lineTracker:string [] = [];

    private _lineHash: IHash = {};
    private _spriteHash: ISpriteHash = {};

    private _lineSprites: PIXI.Sprite [][] = [];

    private _layer:ScalableLayer;

    private _allPoints:PIXI.Point [][] = [];

    private _toggleTl:Timeline | null;
    private _allToggleTl:Timeline [] = [];

    private _testToggleTl:Timeline | null;

    public  individualWinView:HarlequinIndividualWinAmountView;

    constructor(config:IBetLinesViewConfig,
                numberFactoryMethod:(index:number) => BetLineNumber,
                lineFactoryMethod:(index:number, numberPosition:number[], betLineData:number[]) => BetLine) {

        super();

        this._numberFactoryMethod = numberFactoryMethod;
        this._lineFactoryMethod = this.drawMethod;
        this._config = config;

        this.individualWinView= new HarlequinIndividualWinAmountView();
        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.HARLEY_BET_LINES.name);
        this._layer.addChild(this,this.individualWinView);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            //this.position.set(0, 0);
            this.position.set(-280, -170);
            this.scale.set(1, 1);
            this.individualWinView.position.set(0, -70);
        } else {
            this.individualWinView.position.set(-10, 0);
            this.position.set(-210, -40);
            this.scale.set(0.875, 0.875);
        }

    }

    protected initAnimations():void {
        this._resourcesLoaded = true;
        this.draw();

        this.tryToCreateLines();
        //this.testDrawPoints();
    }

    private tryToCreateLines() {
        if(this._resourcesLoaded && this._dataInitialized) {
            this.createTogglingBetlines();
            //this.drawLines();
        }
    }

    private onInitDataParsed(data:ParsedInitData):void {
        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
        this._betLinesData = data.betLines;
        if(this._betLinesData.length != this._config.map.length) {
            debugger;
            throw new Error(`Error: There are only ${this._config.map.length} betLines in the config order while the server sends ${this._betLinesData.length} lines.`);
        }

        this._dataInitialized = true;
        this.draw();
        this.tryToCreateLines();
    }

    protected testAllLines():void {
        const tl:TimelineLite = new TimelineLite();
    }

    protected testDrawPoints():void {
        //debugger;
        this._allPoints.forEach((line) => {
            line.forEach((point) => {
                //console.log("draws on point" + point);
                const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("pearlPoint")[0]);
                sprite.anchor.set(0.45, 0.5);
                //sprite.blendMode = PIXI.BLEND_MODES.ADD;
                sprite.x = point.x;
                sprite.y = point.y;
                this.addChild(sprite);
            });

        });
    }

    protected draw():void {
        if(!this._resourcesLoaded || !this._dataInitialized) {
            return;
        }

        const map:number[] = this._config.map;
        for(let i:number = 0; i < map.length; i++) {
            const betLineNumber:BetLineNumber = this._numberFactoryMethod(map[i]);
            const betLineNumberPosition:number[] = betLineNumber.setPosition(this._betLinesData.length, i);
            this._betLineNumbers.push(betLineNumber);

            const betLine:BetLine = this._lineFactoryMethod(map[i], betLineNumberPosition, this._betLinesData[map[i] - 1]);
            this._betLines.push(betLine);
        }

        this._betLines.sort((a:BetLine, b:BetLine) => {
            return a.index - b.index;
        });

        /*this._betLineNumbers.sort((a:BetLineNumber, b:BetLineNumber) => {
            return a.index - b.index;
        });*/
    }

    protected drawMethod(index:number, numberPosition:number[], betLineData:number[]):PolyBetLine {
        return new PolyBetLine(index, numberPosition, betLineData, {
            staticLineLayer: HarlequinGameConfig.instance.LAYERS.BET_LINES.name,
            styles: [
                {
                    "lineWidth": 3,
                    "color": 0xffffff,
                    "alpha": 1
                },
                {
                    "lineWidth": 1,
                    "color": 0xdfb8cd,
                    "alpha": 1
                }
            ],
            numberOffsetX: 0,
            pointOverlapVerticalOffset: 0
        });
    }

    private createTogglingBetlines() {
        const allPoints: PIXI.Point [][] = [];

        if(this._betLinesData && this._betLinesData.length > 0) {
            this._betLinesData.forEach((betLine, index) => {
                //console.log(OwlsBetLineWinPresentationView.getPointsFromBetLine(betLine, 5));
                const linePoints = HarlequinBetlineView.getPointsFromBetLine(betLine, 5);
                allPoints.push(linePoints);

                //if(index === 0) { // TODO: Temp
                    this._lineSprites.push(this.setupSingleBetline(linePoints, index, betLine));
                //}
            });
        }

        this._allPoints = allPoints;

        //this.tmpDebugHandler();
        //this.toggleTest();
    }

    private tmpDebugHandler():void {
        const ref = this;

        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    if(ref._testToggleTl) {
                        ref._testToggleTl.pause();
                        ref._testToggleTl.kill();
                        ref._testToggleTl = null;
                        ref.hideAllBetlines();
                    }
                    break; // 0
                case 47:
                    if(!ref._testToggleTl) {
                        ref._testToggleTl = ref.toggleTest();
                    }
                    break; // 8
            }
        }, false);
    }

    public toggleTest():Timeline {
        let cntr:number = 0;
        return new TimelineMax({
            repeat: -1
        }).add(() => {

            if(cntr > 19) {
                cntr = 0;
                this.hideBetline(19);
                this.showBetline(cntr);
                cntr++;
            }
            else {
                this.hideBetline(cntr -1);
                this.showBetline(cntr++);
            }
        }, 0.8);
    }

    private static getPointsFromBetLine(betLineData: number [], nrOfSymbols:number = 0):PIXI.Point[]{
        const linePoints:PIXI.Point[] = [];
        const betLine = betLineData;

        for(let i:number = 0; i < nrOfSymbols; i++){
            const symId:number = betLine[i];
            const basePosition:number[] = Helper.getSymbolPositions(i, symId);
            const points = new PIXI.Point(basePosition[0], basePosition[1]);
            linePoints.push(points);
        }
        return linePoints;
    }

    protected toRadians(angle:number):number {
        return angle * (Math.PI / 180);
    }

    protected setupSingleBetline(linePoints:PIXI.Point[], betlineIndex:number, betlineArr:number[]):PIXI.Sprite [] {
        const lineSprites: PIXI.Sprite [] = [];

        for(let i = 0; i < linePoints.length - 1; i++){
            let linePoint:PIXI.Point = linePoints[i];
            let nextLinePoint = new PIXI.Point();

            if(linePoints[i + 1]){
                nextLinePoint = linePoints[i + 1];
            }

            const strId:string = linePoint.x.toString() + linePoint.y.toString() + "_" + nextLinePoint.x.toString() + nextLinePoint.y.toString();
            if(this._lineTracker.indexOf(strId) === -1) {

                const connectingLine: PIXI.Sprite = new PIXI.Sprite();
                connectingLine.visible = false;

                // making sure no index out of bounds
                if(i + 1 < 6) {
                    const pearl:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("pearlPoint")[0]);
                    //pearl.scale.set(1.4, 1.4);
                    pearl.anchor.set(0.45, 0.5);

                    const sprite2: PIXI.Sprite = this.nextPart(betlineArr[i], betlineArr[i + 1]);
                    sprite2.position.set(linePoint.x, linePoint.y);
                    pearl.position.set(linePoint.x, linePoint.y);

                    connectingLine.addChild(sprite2);
                    connectingLine.addChild(pearl);
                }

                if(i === 3) {
                    const lastPearl:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("pearlPoint")[0]);
                    //pearl.scale.set(1.4, 1.4);
                    lastPearl.anchor.set(0.45, 0.5);
                    lastPearl.position.set(nextLinePoint.x, nextLinePoint.y);
                    connectingLine.addChild(lastPearl);
                }

                this.addChild(connectingLine);
                // TODO: Add pearl point at end of line

                connectingLine.name = "bl_index_" + betlineIndex + "_part_" + i;

                this._lineTracker.push(strId);
                this._lineHash[strId] = "bl_index_" + betlineIndex + "_part_" + i;
                this._spriteHash["bl_index_" + betlineIndex + "_part_" + i] = connectingLine;
                lineSprites.push(connectingLine);
            }
            else {
                this._spriteHash["bl_index_" + betlineIndex + "_part_" + i] = this._spriteHash[this._lineHash[strId]];
                lineSprites.push(this._spriteHash[this._lineHash[strId]]);
            }

        }

        return lineSprites;
    }

    public showBetline(index:number, nrOfSymbols:number = 4):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._lineSprites[index]) {
            tl.add(() =>
                this._lineSprites[index].forEach((sprite:PIXI.Sprite) => sprite.visible = true)
            );

            this._toggleTl = tl;
            this._allToggleTl.push(tl);
        }
        //this._spriteHash

        return tl;
    }

    public hideBetline(index:number, nrOfSymbols:number = 4):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._lineSprites[index]) {
            tl.add(() =>
                this._lineSprites[index].forEach((sprite:PIXI.Sprite) => sprite.visible = false)
            );
        }
        //this._spriteHash

        return tl;
    }

    public killBetlines():void {

        if(this._toggleTl) {
            this._toggleTl.pause();
            this._toggleTl.kill();
            this._toggleTl = null;
            this.hideAllBetlines();
        }
    }

    public hideAllBetlines():Timeline {
        const tl:TimelineLite = new TimelineLite();

        this._allToggleTl.forEach((tl) => {
            tl.pause();
            tl.kill();
        });
        this._allToggleTl.length = 0;

        if(this._lineSprites) {

            this._lineSprites.forEach((spriteArr, index) => this.hideBetline(index));

        }

        //this._spriteHash

        return tl;
    }

    protected nextPart(fromYPos:number, toYPos:number):PIXI.Sprite {
        const diff:number =  fromYPos - toYPos;

        //console.log("DIFF: " + diff);

        // Positives, no mirror
        if(diff === 0 || diff === -0) {
            const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("straightPearls")[0]);
            sprite.anchor.set(-0.4, 0.5);
            return sprite;
            //return sprite;//0.95;
        }
        else if(diff === 1) {
            const sprite:PIXI.Sprite =  new PIXI.Sprite(GameResources.getTextures("smallCurvePearls")[0]);
            sprite.anchor.set(-0.35, 1);
            return sprite;
        }
        else if(diff === 2) {
            const sprite:PIXI.Sprite =  new PIXI.Sprite(GameResources.getTextures("largeCurvePearls")[0]);
            sprite.anchor.set(-0.5, 1);
            return sprite;
        }

        // Y scale -1
        else if(diff === -1) {
            const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("smallCurvePearls")[0]);
            sprite.anchor.set(-0.35, 1);
            sprite.scale.set(1, -1);
            //sprite.rotation = this.toRadians(180);
            return sprite;

        }
        else if(diff === -2) {
            const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("smallCurvePearls")[0]);
            sprite.anchor.set(-0.35, 1);
            sprite.scale.set(1, -1);
            //sprite.rotation = this.toRadians(180);
            return sprite;
        }

        return new PIXI.Sprite();
    }

}